import { useMutation } from "@apollo/react-hooks";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Row,
  Typography,
} from "antd";
import React from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useHistory } from "react-router-dom";
import SignupImage from "../../../Assets/Images/002.jpg";
import { CustIcon } from "../../../Components/Svgs";
import { SIGNUP_USER } from "../../../Graphql/mutations";
import "./Signup.less";

const { Title } = Typography;

export const SignupPage = () => {
  const [form] = Form.useForm();
  const history = useHistory();

  const [SIGNUP_USER_MUTATION, { loading: isFormSubmitting }] = useMutation(
    SIGNUP_USER,
    {
      context: {
        headers: {
          nologin: 1,
        },
      },
    }
  );

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const tailLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const onFinish = async ({
    // role_id: data?.user_role[0]?.id,
    firstname,
    lastname,
    phone,
    email,
    password,
  }) => {
    const variables = {
      first_name: firstname,
      last_name: lastname,
      phone,
      email,
      password,
    };
    try {
      let { data: signupResponse, errors } = await SIGNUP_USER_MUTATION({
        variables,
      });
      if(errors?.length > 0){
        message.error(errors[0].message)
      }
      if (signupResponse.insert_owner.user_id) {
        localStorage.clear();
        localStorage.setItem("user_id", signupResponse.insert_owner.user_id);
        localStorage.setItem(
          "sanattest_access_token",
          signupResponse.insert_owner.access_token
        );
        history.push("/otp-verification", {
          nextPage: "/on-boarding/business-details",
        });
      }
    } catch (errors) {
      if (
        errors?.graphQLErrors &&
        errors?.graphQLErrors[0]?.extensions?.code === "constraint-violation"
      ) {
        if (errors?.graphQLErrors[0].message.includes("phone")) {
          form.setFields([
            {
              name: "phone",
              errors: ["Phone number already in-use"],
            },
          ]);
        }
        if (errors?.graphQLErrors[0].message.includes("email")) {
          form.setFields([
            {
              name: "email",
              errors: ["Email Id already in-use"],
            },
          ]);
        }
      }
    }
  };

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={SignupImage} alt="" />
      </div>
      <div className="colSec onBoardingRight">
        <div className="step_2">
          <p className="text-right text-step">Step 1 of 6</p>
          <Title level={2}>
            <CustIcon type="left-arrow" onClick={() => history.goBack()} />
            Let's get you set up!
          </Title>
          <p className="subTitle">
            Fill out some basic details about your business so we can help you
            get started with SanAttest. <strong>First 30-days are free!</strong>
          </p>

          <Form
            form={form}
            {...layout}
            id="newuser-form"
            name="userForm"
            onFinish={onFinish}
          >
            <Row gutter={16}>
              <Col span={24}>
                <label title="What is your full name?" className="mb-2">
                  What is your full name?
                </label>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  htmlFor="firstname"
                  name="firstname"
                  normalize={(value) => {
                    return !value
                      ? ""
                      : value.charAt(0).toUpperCase() + value.slice(1);
                  }}
                  rules={[
                    {
                      required: true,
                      message: "First Name is required",
                      whitespace: true,
                    },
                    {
                      pattern: new RegExp(
                        "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$"
                      ),
                      message: "Invalid First name",
                    },
                  ]}
                >
                  <Input placeholder="Enter First Name" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  htmlFor="lastname"
                  name="lastname"
                  normalize={(value) => {
                    return !value
                      ? ""
                      : value.charAt(0).toUpperCase() + value.slice(1);
                  }}
                  rules={[
                    {
                      required: true,
                      message: "Last Name is required",
                      whitespace: true,
                    },
                    {
                      pattern: new RegExp(
                        "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$"
                      ),
                      message: "Invalid Last name",
                    },
                  ]}
                >
                  <Input placeholder="Enter Last Name" />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              label="What is your phone number?"
              name="phone"
              htmlFor="phone"
              rules={[
                {
                  required: true,
                  message: "Phone Number is required",
                  whitespace: true,
                },
                () => ({
                  validator(_, value) {
                    if (value && isValidPhoneNumber(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Enter Valid Phone Number")
                    );
                  },
                }),
              ]}
            >
              <PhoneInput
                className="phoneInput_blk"
                defaultCountry="US"
                placeholder="(201) 555-1234"
                countryOptionsOrder={["US","CA","|","..."]}
              />
            </Form.Item>

            <Form.Item
              label="What is your email id?"
              name="email"
              htmlFor="email"
              normalize={(value) => {
                return !value ? "" : value.toLowerCase();
              }}
              rules={[
                {
                  required: true,
                  message: "Email Address is required",
                  whitespace: true,
                },
                {
                  type: "email",
                  message: "Enter Valid Email Address",
                },
              ]}
            >
              <Input placeholder="john.dow@sanattest.com" />
            </Form.Item>
            <Row gutter={16}>
              <Col xs={24} sm={12} md={12}>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                      whitespace: true,
                    },
                    {
                      pattern: new RegExp(
                        "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-+.,|_~`'\"]).{6,}$"
                      ),
                      message:
                        "Minimum 6 characters at least 1 Uppercase Alphabet, 1 Lowercase Alphabet, 1 Number and 1 Special Character!",
                    },
                  ]}
                  hasFeedback
                >
                  <Input.Password placeholder="Enter New Password" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={12}>
                <Form.Item
                  name="confirm"
                  label="Confirm Password"
                  dependencies={["password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The two passwords that you entered do not match!"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Confirm Password" />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  name="terms"
                  valuePropName="checked"
                  rules={[
                    {
                      validator: (_, value) =>
                        value
                          ? Promise.resolve()
                          : Promise.reject(
                              new Error("Please accept terms and conditions")
                            ),
                    },
                  ]}
                >
                  <Checkbox className="typeCheckboxGroup">
                    I agree with SanAttest
                    <Button
                      className="p-1"
                      type="link"
                      onClick={() =>
                        window.open("https://sanattest.com/terms-conditions/")
                      }
                    >
                      Terms and Conditions
                    </Button>
                    and
                    <Button
                      className="p-1"
                      type="link"
                      onClick={() =>
                        window.open("https://sanattest.com/privacy-policy/")
                      }
                    >
                      Privacy Policy
                    </Button>
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item {...tailLayout} className="buttonSec pt-2">
              <Button
                loading={isFormSubmitting}
                type="primary"
                shape="round"
                size="large"
                htmlType="submit"
              >
                {isFormSubmitting ? "Submitting" : "Register"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
